module.exports = __webpack_public_path__ + "static/media/open-in-new.c5be902d.svg";